<template>
    <div class="search-head">
        <span>
            <el-input v-model="searchValue" :class="['home-input-box', inputClass]" size="mini"
                placeholder="搜索客户、商机、合同..." @clear="clearHandle" @focus="isShowOptions = true"
                @blur="isShowOptions = false" @input="inputHandle" @keydown.enter.native="handleIconClick">
                <i slot="suffix" class="custom-icon" @click="handleIconClick"></i>
            </el-input>
        </span>
        <!-- <el-popover placement="bottom" :width="widthPopper" trigger="manual" popper-class="search-popper"
            :visible-arrow="false" v-model="isShowOptions">
            <el-input slot="reference" v-model="searchValue" :class="['home-input-box', inputClass]" size="mini"
                placeholder="搜索客户、商机、合同..." @clear="clearHandle" clearable @focus="isShowOptions = true"
                @blur="isShowOptions = false" @input="inputHandle" @keydown.enter.native="handleIconClick">
                <i slot="suffix" class="custom-icon" @click="handleIconClick"></i>
            </el-input>
            <div class="search-complete-list">
                <p class="search-complete-list-item" v-for="(option, index) in filteredOptions" :key="index"
                    @click="selectOption(option)">
                    {{ option }}
                </p>
            </div>
        </el-popover> -->
    </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
export default {
    components: {},
    props: {
        detailDataLocal: {
            type: Object,
            return: () => { }
        },
        widthPopper: {
            type: [String, Number],
            default: () => {
                return '500';
            }
        },
        inputClass: {
            type: String,
            default: () => {
                return '';
            }
        },
        inputValue: {
            type: String,
            default: () => {
                return '';
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const inputText = ref('');
        const searchValue = ref('');
        const isShowOptions = ref(false);
        const filteredOptions = ref([]);
        watch(() => props.inputValue, (val) => {
            searchValue.value = val;
        }, { deep: true, immediate: true });
        const inputHandle = async (val) => {
            setupContext.emit('inputHandle', val);
            if (!val.length) {
                isShowOptions.value = false;
                return;
            }
            isShowOptions.value = true;

            if (!val) {
                this.filteredOptions = [];
                return;
            }
            try {
                // 联想接口请求
                // const response = await fetch(`/api/options?query=${val}`);
                // const options = await response.json();
                // this.filteredOptions = options;
            } catch (error) {
                console.error('Failed to fetch options:', error);
            }
        };
        const selectOption = (option) => {
            inputText.value = option;
            isShowOptions.value = false;
            filteredOptions.value = [];
            setupContext.emit('clickItem', option);
        };

        const clearHandle = () => {

        };

        const handleIconClick = () => {
            isShowOptions.value = false;
            setupContext.emit('handleIconClick', searchValue.value);
        };
        return {
            searchValue,
            inputText,
            filteredOptions,
            selectOption,
            isShowOptions,
            clearHandle,
            inputHandle,
            handleIconClick
        };
    }
};
</script>
<style lang="less" scoped>
.search-head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .home-input-box {
        // background: #FFFFFF;
        height: 36px;
        width: 500px;
    }

}

.custom-icon {
    background: url('../../../assets/images/icon-search.png') center/cover;
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 16px;
    margin-top: 9px;
    cursor: pointer;
}
</style>
<style lang="less">
.search-popper {
    // width: 474px !important;
    // top: 115px !important;
    // left: 230px;

    .search-complete-list {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        height: 220px;
        overflow-y: auto;

        .search-complete-list-item {
            margin: 0;
            padding: 7px 0;
            cursor: pointer;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .search-complete-list-item:hover {
            background: #F3F4F6;
        }
    }
}

.home-input-box.el-input .el-input__inner {
    border-radius: 18px;
    padding-left: 16px;
    padding-right: 57px;
    height: 36px;
    line-height: 36px;
}

// .search-bottom-radius.el-input .el-input__inner {
//     border-bottom-left-radius: 0px !important;
//     border-bottom-right-radius: 0px !important;
// }

.home-input-box.el-input .el-input__suffix .el-input__clear {
    line-height: 36px;
}

.home-input-box {
    .el-input__suffix {
        &-inner {
            flex-direction: row-reverse;
            -webkit-flex-direction: row-reverse;
            display: flex;
        }
    }
}
</style>
